<div>
  <div class="header-style">
    <div class="h-100">
      @if (authService.getUserData().type === utils.userTypes.Distributor || authService.getUserData().type === utils.userTypes.DistributorChild) {
        <mat-form-field appearance="outline" class="select">
          <mat-select data-testid="usedOnMobile_filter" (selectionChange)="filterChange($event.value)" [(value)]="selected" #usedOnMobile_filter  id="usedOnMobile_filter"
            name="usedOnMobile_filter">
            <mat-option i18n="@@MarketingMaterialsUsedonmobile" value="usedOnMobile">Marketing Materials Used on mobile</mat-option>
            <mat-option i18n="@@MarketingMaterialsToPickFrom" value="manufacturer">Marketing Materials To Pick From</mat-option>
          </mat-select>
        </mat-form-field>
      }
    </div>

    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>

      @if (user.type !== utils.userTypes.Admin) {
        <mat-icon data-testid="add_material_button" (click)="openAddMaterial()" class="cursor add-icon" svgIcon="add" aria-hidden="false" i18n-label="@@addMaterialIcon" aria-label="Add Material"></mat-icon>
      }

      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="material_search_input" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon data-testid="material_clear_button" class="cursor" matSuffix i18n-label="@@clearSearchIcon" aria-label="Clear Search" (click)="clearSearch()">clear</mat-icon>
          </mat-form-field>
        }
      </form>

      <mat-icon data-testid="material_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" i18n-label="@@searchIcon" aria-label="Search"></mat-icon>
    </div>
  </div>

  @for (item of materialsList; track item; let itemIndex = $index) {
    <mat-card class="simple-card cursor">
      <mat-card-content>
        <div class="flex-grow d-flex justify-content-between cursor">
          <div class="flex-grow" (click)="openMaterialDetails(item.id)">
            <div class="mat-subtitle-1 mb-12" matTooltip ellipsisTooltip>{{item.name}}</div>
            <div class="mat-caption" matTooltip ellipsisTooltip>{{item.description}}</div>
          </div>

          @if (user.type === utils.userTypes.Manufacturer || user.type === utils.userTypes.ManufacturerChild) {
            <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-label="@@moreOptionsIcon" aria-label="More Options">more_vert</mat-icon>
          }

          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'manufacturer') {
            <mat-icon class="{{item.usedOnMobile ? 'cursor header-icon' : 'header-icon-color cursor'}}" (click)="item.usedOnMobile ? moveToNotUsedOnMobile(item.id) : moveToUsedOnMobile(item.id)" i18n-label="@@toggleUsedOnMobileIcon" aria-label="Toggle Used on Mobile">stay_current_portrait</mat-icon>
          }

          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === true) {
            <mat-icon class="cursor header-icon" (click)="moveToNotUsedOnMobile(item.id)" i18n-label="@@removeFromUsedOnMobileIcon" aria-label="Remove from Used on Mobile">stay_current_portrait</mat-icon>
          }

          @if ((user.type === utils.userTypes.Distributor || user.type === utils.userTypes.DistributorChild) && selected === 'usedOnMobile' && item.isAddedByManufacturer === false) {
            <mat-icon class="cursor" [matMenuTriggerFor]="menu" color="accent" i18n-label="@@moreOptionsIcon" aria-label="More Options">more_vert</mat-icon>
          }
        </div>

        <mat-menu #menu="matMenu">
          <button i18n="@@edit" data-testid="edit_material_button" (click)="openEditMaterial(item.id, item)" mat-menu-item>Edit</button>
          <button i18n="@@delete" data-testid="delete_material_button" (click)="deleteMaterial(item.id)" mat-menu-item>Delete</button>
        </mat-menu>
      </mat-card-content>
    </mat-card>
  }

  @if (materialsList.length === 0) {
    <img class="empty-view-img" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}" i18n-alt="@@emptyViewImageAlt" alt="No materials available">
  }
</div>